import { InjectionToken, type Type } from '@angular/core';
import type { SpinoffTwoFactorAuthDialogComponent } from './spinoff-two-factor-auth-dialog.component';

export type { SpinoffTwoFactorAuthDialogComponent };

/**
 * 투팩터 인증 다이얼로그 컴포넌트를 지연 로딩한다. Material form-field·input을 쓰는 이 컴포넌트는 428을 처음 만났을 때만 필요해
 * 정적 import로 두면 앱 초기 번들에 실린다(`loadSpinoffCreateOrgDialog`와 같은 이유). 배럴로 export하지 않는다.
 */
export async function loadSpinoffTwoFactorAuthDialog(): Promise<Type<SpinoffTwoFactorAuthDialogComponent>> {
  const { SpinoffTwoFactorAuthDialogComponent } = await import('./spinoff-two-factor-auth-dialog.component');
  return SpinoffTwoFactorAuthDialogComponent;
}

/** 로더를 주입해 쓰게 하는 토큰 — 테스트가 실제 청크를 받지 않고 대체할 수 있다. 기본값은 위 함수다(앱이 제공할 필요 없음). */
export const SPINOFF_TWO_FACTOR_AUTH_DIALOG_LOADER = new InjectionToken<() => Promise<Type<SpinoffTwoFactorAuthDialogComponent>>>(
  'SPINOFF_TWO_FACTOR_AUTH_DIALOG_LOADER',
  { providedIn: 'root', factory: () => loadSpinoffTwoFactorAuthDialog },
);
